import { Theme } from "@emotion/react";
import { Box, styled } from "@mui/material";

type ISwitcheProps = {
  darkMode: boolean;
  theme?: Theme;
};

export const SwitchWrapper = styled(
  Box,
  {},
)<ISwitcheProps>(({ darkMode, theme }) => ({
  "&.switch-container": {
    paddingLeft: "5px",
    [theme.breakpoints.down("md")]: {
      padding: "15px 0px",
      paddingLeft: "15px",
    },
    ".switch": {
      position: "relative",
      display: "inline-block",
      width: "31px",
      height: "19px",
      input: {
        opacity: 0,
        width: 0,
        height: 0,
      },
      ".slider": {
        position: "absolute",
        cursor: "pointer",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: darkMode ? "white" : "black",
        transition: "0.4s",
        border: "1px solid black",
        borderRadius: "34px",
      },
      ".slider:before": {
        position: "absolute",
        content: '""',
        height: "13px",
        width: "13px",
        left: "2px",
        bottom: "2px",
        backgroundColor: darkMode ? "black" : "white",
        transition: "transform 0.4s",
        borderRadius: "50%",
      },
      "input:checked + .slider": {
        backgroundColor: "white",
      },
      "input:focus + .slider": {
        boxShadow: "0 0 1px white",
      },
      "input:checked + .slider:before": {
        transform: "translateX(12px)",
      },
    },
  },
}));
